import { Locale } from '../../i18n/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.locale('en-only-date', {});
// TODO: Check if the time after isFuture is actually today, or yesterday
dayjs.updateLocale('en-only-date', {
  relativeTime: {
    future: '%s',
    past: '%s',
    s: function () {
      return 'today';
    },
    m: function () {
      return 'today';
    },
    mm: function () {
      return 'today';
    },
    h: function () {
      return 'today';
    },
    hh: function () {
      return 'today';
    },
    d: function (
      _value: number,
      _withoutSuffix: boolean,
      _key: string,
      isFuture: boolean,
    ) {
      return isFuture ? 'tomorrow' : 'yesterday';
    },
    dd: function (
      value: number,
      _withoutSuffix: boolean,
      _key: string,
      isFuture: boolean,
    ) {
      return isFuture ? `in ${value} days` : `${value} days ago`;
    },
    M: function (
      _value: number,
      _withoutSuffix: boolean,
      _key: string,
      isFuture: boolean,
    ) {
      return isFuture ? `in a month` : `a month ago`;
    },
    MM: function (
      value: number,
      _withoutSuffix: boolean,
      _key: string,
      isFuture: boolean,
    ) {
      return isFuture ? `in ${value} months` : `${value} months ago`;
    },
    y: function (
      _value: number,
      _withoutSuffix: boolean,
      _key: string,
      isFuture: boolean,
    ) {
      return isFuture ? `in a year` : `a year ago`;
    },
    yy: function (
      value: number,
      _withoutSuffix: boolean,
      _key: string,
      isFuture: boolean,
    ) {
      return isFuture ? `in ${value} years` : `${value} years ago`;
    },
  },
});

export enum DateFormat {
  Date = 'YYYY-MM-DD',
  Datetime = 'YYYY-MM-DD HH:mm UTC',
  DateWeekday = 'ddd DD',
}

export function formatDate(
  locale: Locale,
  dateString?: string,
  dateFormat: DateFormat = DateFormat.Date,
): string {
  if (!dateString) return '';
  return dayjs(dateString).locale(locale).format(dateFormat);
}

export function dateFromNow(locale: Locale, dateString: string) {
  return dayjs(dateString).locale(locale).fromNow();
}

export function currentDateOnlyDateToString() {
  return new Date().toISOString().substring(0, 10);
}

// Convert ISO string to YYYY-MM-DD format for date input
export function toDateInputValue(isoString: string | null): string {
  if (!isoString) return '';
  try {
    const date = new Date(isoString);
    return date.toISOString().split('T')[0];
  } catch {
    return '';
  }
}

// Convert YYYY-MM-DD to ISO string (start of day in UTC)
export function toISOString(dateString: string): string | null {
  if (!dateString) return null;
  try {
    const date = new Date(dateString + 'T00:00:00.000Z');
    return date.toISOString();
  } catch {
    return null;
  }
}
